import dayjs from 'dayjs';

export function normalizeSchedulesData(data) {
  const normalizedData = data?.schedules?.map((time) => ({
    time: time ? dayjs(time, 'HH:mm') : null,
  }));

  return normalizedData;
}
